import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";

function AutosaveIndicator({ status, lastEditedAt }) {
  if (status === "pending") {
    return (
      <Chip
        color="warning"
        variant="outlined"
        icon={<CircularProgress size={14} />}
        label="Autosaving"
      />
    );
  }

  if (lastEditedAt) {
    return (
      <Chip
        color="success"
        variant="outlined"
        label={`Autosaved ${new Date(lastEditedAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`}
      />
    );
  }

  return <Chip color="default" variant="outlined" label="Autosave ready" />;
}

export default AutosaveIndicator;
